import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { isMobile } from "../common/util/utils";

const VideoPlayerPage = () => {
    const [src, setSrc] = useState('')

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        const mode = !isMobile() ? 'desktop' : 'mobile';
        // Fetch the data from the JSON file
        fetch('/help/videos.json')
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                const url = data.find(v => v.code === code);
                if (url) {
                    console.log('url ', url);

                    setSrc(url.videoUrl);
                }
            })
            .catch((error) => {
                console.log(error);

            });
    }, []);

    return (
        <ReactPlayer
            src={src}
            controls
            width="100%"
            height="100%"
        />
    );
};

export default VideoPlayerPage;
